import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, Icon, Dropdown, Menu, Checkbox, Popconfirm } from 'antd';

import { SOCKET_EVENTS, CHAT_STATE, REVIEW_STATUS } from '../../../../../../data/config/constants';
import { IconMenuDot } from '../../../../../../data/assets/icons';

import ProfileAvatar from '../../../../../../components/profileavatar';

class ChatHeader extends React.PureComponent {
  state = {
    visible: false,
  };

  handleVisibleChange = visible => {
    this.setState({ visible });
  };

  handleMenuClick = e => {
    if (e.key !== 'escalate' && e.key !== 'blank') {
      this.setState({ visible: false });
    }
  };

  onClickSync = () => {
    this.props.handleChatEvent(SOCKET_EVENTS.JOIN_ROOM);
  }

  startSupervising = () => {
    this.props.handleChatEvent(SOCKET_EVENTS.SUPERVISE);
  };

  stopSupervising = () => {
    this.props.handleChatEvent(SOCKET_EVENTS.STOP_SUPERVISING);
  };

  resolveChat = () => {
    this.props.handleChatEvent(SOCKET_EVENTS.RESOLVE_CHAT);
  };

  onClickReviewDone = () => {
    this.props.handleChatEvent('reviewDone', REVIEW_STATUS.COMPLETE);
  };

  onClickForceTakeover = () => {
    this.props.handleChatEvent(SOCKET_EVENTS.FORCE_TAKEOVER);
  };

  onChangeEscalate = e => {
    this.props.handleChatEvent(SOCKET_EVENTS.ESCALATE, e.target.checked, this.handleVisibleChange);
  };

  onChangeBlank = e => {
    this.props.handleChatEvent(SOCKET_EVENTS.BLANK, e.target.checked, this.handleVisibleChange);
  };

  render() {
    const { active_chat_item, admin_id, handleChatEvent, onClickDownloadChatlogs, onClickTransfer, onClickClose, event_permissions } = this.props;
    const title = active_chat_item && active_chat_item.udf1 && active_chat_item.udf1.trim().length > 0 ? active_chat_item.udf1 : "Unknown";
    return (
      <div className="ori-lr-pad-15 ori-full-parent-height ori-flex-row ori-flex-jsb">
        {
          active_chat_item &&
          <div className="ori-flex-column ori-flex-jc">
            <ProfileAvatar title={title} timestamp={active_chat_item.lastMessageTimeStamp} />
          </div>
        }
        {
          active_chat_item &&
          <div className="ori-flex-row ori-flex-ac">
            {
              handleChatEvent && active_chat_item.chatState === CHAT_STATE.AGENT_HANDLING && active_chat_item.agentId === admin_id &&
              <Button size="small" className="ori-animated ori-fade-in ori-font-xs ori-lr-mrgn-5 ori-btn-fill-danger" onClick={this.resolveChat}>Resolve Chat</Button>
            }
            {
              event_permissions.supervise && handleChatEvent && active_chat_item.chatState === CHAT_STATE.AGENT_HANDLING && active_chat_item.agentId !== admin_id && active_chat_item.supervisorId === "" &&
              <Button size="small" type="primary" className="ori-animated ori-fade-in ori-font-xs ori-lr-mrgn-5" onClick={this.startSupervising}>Supervise Chat</Button>
            }
            {
              event_permissions.supervise && handleChatEvent && active_chat_item.chatState === CHAT_STATE.AGENT_HANDLING && active_chat_item.agentId !== admin_id && active_chat_item.supervisorId === admin_id &&
              <Button size="small" className="ori-animated ori-fade-in ori-font-xs ori-lr-mrgn-5 ori-btn-fill-danger" onClick={this.stopSupervising}>Stop Supervising</Button>
            }
            {
              event_permissions.reviewChat && handleChatEvent && active_chat_item.reviewStatus === REVIEW_STATUS.PENDING &&
              <Popconfirm title="Are you sure to complete this review?" okText="Yes" cancelText="No" onConfirm={this.onClickReviewDone}>
                <Button size="small" className="ori-animated ori-fade-in ori-font-xs ori-lr-mrgn-5 ori-btn-fill-danger" >Review Done</Button>
              </Popconfirm>
            }
            {
              handleChatEvent && active_chat_item.chatState === CHAT_STATE.AGENT_HANDLING &&
              <Button className="ori-font-light ori-font-bold ori-l-mrgn-5" style={{ lineHeight: '24px' }} type="default" icon="sync" size="small" shape="circle" onClick={this.onClickSync} />
            }
            <Dropdown placement="bottomRight" onVisibleChange={this.handleVisibleChange} visible={this.state.visible} trigger={['click']} overlay={
              <div style={{ paddingTop: "15px" }}>
                <Menu className="ori-box-shadow-light ori-border-light ori-overflow-hidden ori-bl-border-radius-5 ori-br-border-radius-5" onClick={this.handleMenuClick}>
                  {
                    handleChatEvent && active_chat_item.chatState === CHAT_STATE.AGENT_HANDLING && active_chat_item.agentId === admin_id &&
                    <Menu.Item key="blank" className="ori-no-mrgn ori-bg-white-hover-primary-light">
                      <Checkbox className="ori-font-default-hover-primary" style={{ fontWeight: 400 }} checked={active_chat_item.blank === "true"} onChange={this.onChangeBlank}>Blank chat</Checkbox>
                    </Menu.Item>
                  }
                  {
                    handleChatEvent && active_chat_item.chatState === CHAT_STATE.AGENT_HANDLING && active_chat_item.agentId === admin_id &&
                    <Menu.Item key="escalate" className="ori-no-mrgn ori-bg-white-hover-primary-light">
                      <Checkbox className="ori-font-default-hover-primary" style={{ fontWeight: 400 }} checked={active_chat_item.escalate === "true"} onChange={this.onChangeEscalate}>Escalate chat</Checkbox>
                    </Menu.Item>
                  }
                  {
                    onClickDownloadChatlogs &&
                    <Menu.Item key="download" className="ori-no-mrgn ori-bg-white-hover-primary-light" onClick={onClickDownloadChatlogs}>
                      <Icon type="download" className="ori-font-15" />
                      Download chatlogs
                    </Menu.Item>
                  }
                  {
                    onClickTransfer && active_chat_item.chatState === CHAT_STATE.AGENT_HANDLING && active_chat_item.agentId === admin_id &&
                    <Menu.Item key="transfer" className="ori-no-mrgn ori-bg-white-hover-primary-light" onClick={onClickTransfer}>
                      <Icon type="export" className="ori-font-15" />
                      Transfer chat
                    </Menu.Item>
                  }
                  {
                    handleChatEvent && active_chat_item.chatState === CHAT_STATE.AGENT_HANDLING && active_chat_item.agentId !== admin_id && active_chat_item.supervisorId === admin_id &&
                    <Menu.Item key="forceTakeover" className="ori-no-mrgn ori-bg-white-hover-primary-light" onClick={this.onClickForceTakeover}>
                      <Icon type="import" className="ori-font-15" />
                      Force Takeover
                    </Menu.Item>
                  }
                  <Menu.Item key="close" className="ori-no-mrgn ori-bg-white-hover-primary-light" onClick={onClickClose}>
                    <Icon type="close" className="ori-font-15" />
                    Close chat window
                  </Menu.Item>
                </Menu>
              </div>
            }>
              <div className="ori-font-light-hover-primary">
                <IconMenuDot size={22} />
              </div>
            </Dropdown>
          </div>
        }
      </div>
    );
  }
}

const CheckboxMenuItem = props => {
  const { key, checked, text, onChange } = props;
  return (
    <Menu.Item key={key} className="ori-no-mrgn ori-bg-white-hover-primary-light">
      <Checkbox className="ori-font-default-hover-primary" style={{ fontWeight: 400 }} checked={checked} onChange={onChange}>{text}</Checkbox>
    </Menu.Item>
  );
};

const mapStateToProps = state => {
  return {
    admin_id: state.admin_details.admin_id,
    event_permissions: state.admin_details.user_info.permissions && state.admin_details.user_info.permissions.events ? state.admin_details.user_info.permissions.events : {},
  };
};

CheckboxMenuItem.propTypes = {
  key: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  text: PropTypes.string,
  onChange: PropTypes.func,
};

ChatHeader.propTypes = {
  active_chat_item: PropTypes.object,
  admin_id: PropTypes.string,
  onClickTransfer: PropTypes.func,
  onClickClose: PropTypes.func,
  onClickDownloadChatlogs: PropTypes.func,
  handleChatEvent: PropTypes.func,
  event_permissions: PropTypes.object
};

ChatHeader.defaultProps = {
  onClickClose: () => { },
};

export default connect(mapStateToProps)(ChatHeader);



// WEBPACK FOOTER //
// ./src/app/pagecontainer/components/chatinterface/components/chatheader/index.js